<template>
  <v-app>
    <v-toolbar
      app
      :clipped-left="clipped"
      class="grey darken-3"
      dark
      dense
    >
      <img src="@/assets/lizard.png" height="32px" class="hidden-xs-only">
      <v-toolbar-title v-text="title" class="ml-2 app-title"></v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn icon @click.stop="rightDrawer = !rightDrawer">
        <v-icon>menu</v-icon>
      </v-btn>
    </v-toolbar>
    <v-content>
      <router-view/>
    </v-content>
    <v-navigation-drawer
      temporary
      :right="right"
      v-model="rightDrawer"
      fixed
      app
    >
      <v-list>
          <v-subheader>Switch Connectors</v-subheader>
        <v-list-tile>
          <v-list-tile-action>
            <v-icon>compare_arrows</v-icon>
          </v-list-tile-action>
          <v-list-tile-title>
            <a href="https://screenprinting.magic-gecko.com">
              Screenprinting site connector
            </a>
          </v-list-tile-title>
        </v-list-tile>
          <v-list-tile><!--@click="right = !right"-->
              <v-list-tile-action>
                  <v-icon>compare_arrows</v-icon>
              </v-list-tile-action>

              <v-list-tile-title> <!-- TODO :: Update to roqus.magic-gecko.com -->
                <a href="https://darcwebapp-roqus.herokuapp.com/">
                  Roq site connector
                </a>
              </v-list-tile-title>
          </v-list-tile>

        <v-list-tile><!--@click="right = !right"-->
          <v-list-tile-action>
            <v-icon>compare_arrows</v-icon>
          </v-list-tile-action>

          <v-list-tile-title>
            <a href="https://sandbox.magic-gecko.com">
              Sandbox site connector
            </a>
          </v-list-tile-title>
        </v-list-tile>
      </v-list>
    </v-navigation-drawer>
    <v-footer :fixed="fixed" app dark color="grey darken-3">
      <span class="pl-2"> Ryonet &copy; {{thisYear}}</span>
    </v-footer>
  </v-app>
</template>

<script>

export default {
  name: 'App',
  data () {
    return {
      clipped: true,
      drawer: true,
      fixed: false,
      thisYear: '',
      items: [{
        icon: 'open_in_new',
        title: 'item'
      },
      {
          icon: 'open_in_new',
          title: 'order'
      },
      {
          icon: 'open_in_new',
          title: 'customer'
      }],
  miniVariant: false,
      right: true,
      rightDrawer: false,
      title: 'Magicgecko'
    }
  },
  created() {
    this.thisYear = new Date().getFullYear();
  }
}
</script>

<style scoped>
  @import url('https://fonts.googleapis.com/css?family=Mogra');
  .app-title{
    font-family: 'Mogra', cursive;
    font-size: 25px;
  }
</style>
